import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useLocation, useNavigate } from 'react-router-dom';
import Classes from './Navbar.module.css';
import Logo from '../Logo/Logo';
import { scrollToElement } from '../../../../../utils/scrollToElement';

export default function Navbar() {
    const navigateTo = useNavigate();
    const location = useLocation();
    const [activePage, setActivePage] = useState(location.pathname);

    useEffect(() => {
        setActivePage(location.pathname);
    }, [location.pathname]);

    const [width, setWidth] = useState(
        typeof window !== 'undefined' ? window.innerWidth : 0
    );

    const handleScrollOrNavigate = (id, offset = 0) => {
        if (location.pathname !== '/') {
            navigateTo('/', { state: { scrollTo: { id, offset } } });
        } else {
            scrollToElement(id, offset);
        }
    };

    useEffect(() => {
        function handleResize() {
            setWidth(window.innerWidth);
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <motion.div className={Classes.navbar} >
            <div style={{ display: 'flex' }} >
                <a href="/" style={{ textDecoration: 'none' }} className={Classes.logoMargin} >
                    <div>
                        <Logo alwaysShowText={true} />
                    </div>
                </a>
            </div>
            <ul>
                <li
                    onClick={() => handleScrollOrNavigate('howItWorks', 20)}
                    className={Classes.navActive}
                >
                    <h5>How it Works</h5>
                </li>
                <li
                    onClick={() => handleScrollOrNavigate('features', 20)}
                    className={Classes.navActive}
                >
                    <h5>Features</h5>
                </li>
                <li
                    onClick={() => handleScrollOrNavigate('pricing', 25)}
                    className={Classes.navActive}
                >
                    <h5> Pricing </h5>
                </li>
                <li
                    onClick={() => handleScrollOrNavigate('faq', 70)}
                    className={Classes.navActive}
                >
                    <h5> FAQ </h5>
                </li>
            </ul>
            <div className={Classes.gridRight}>
                <button onClick={() => { navigateTo('/login') }} className={Classes.leftBtn}>
                    <h5> Sign In </h5>
                </button>
                <button type='button' onClick={() => { navigateTo('/join') }} className={Classes.startBtn}>
                    <h5> {width <= 1100 ? 'Sign up' : 'Get Started'} </h5>
                </button>
            </div>
        </motion.div>
    );
}
